import React from 'react';

import { type EmojiId, yatSplitter } from '@app/client';

import { ChipSize, type ChipSizeValue } from '../../Chip';

import { ChipYatWrapper, Yat } from './styles';

export interface ChipYatProps {
    yat?: EmojiId;
    size?: ChipSizeValue;
}

export function ChipYat({ yat, size = ChipSize.Medium }: ChipYatProps) {
    const yatMarkup = yatSplitter(yat)?.map((emoji, index) => (
        <Yat key={`${emoji}-${index}`} forceSprite={false} emojiID={emoji} />
    ));

    return yatMarkup?.length ? <ChipYatWrapper $size={size}>{yatMarkup}</ChipYatWrapper> : null;
}
